export default '/build/972f462d.svg'